import { Organization, SurveyCompleteUser } from '../models';
import { HasId } from '../interfaces';

export class Team implements HasId {
    public id: number;
    public name: string;
    public organization: Organization;
    public surveyCompleteUser: SurveyCompleteUser[];
    public isManager: boolean;
    public isMember: boolean;
}


// WEBPACK FOOTER //
// ./src/models/Team.tsx